import ReactCountryFlag from "react-country-flag";
import { BRAND } from "@core/brand/brand-config";
import styles from "./ProfileHeader.module.scss";
import ProfileHeaderText from "./ProfileHeaderText.jsx";
import ProfileHeaderPill from "./ProfileHeaderPill.jsx";
import LoadingSkeleton from "../../../../shared/LoadingSkeleton/index.jsx";
import { handleCopy } from "@helpers/profileHelper";
import { Form } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import { CLOUDINARY_INTEL_BASE_URL, CLOUDINARY_INTEL_URL, ERROR_MSG, profileType as type } from "@utils/enum";
import AddFavModal from "@shared/AddFavModal";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CompanyProfileEmailAlertModal from "@routes/intel/us/company-profile/company-profile-email-alert-modal";
import axios from "axios";
import { getApiUrl } from "@utils/baseUrl";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getIntelUrl } from "@utils/intelUrl";
import { parentStatusHandler, resetCachingHandler } from "@redux/CompanyProfile/companyProfileSlice";
import { Helmet } from "react-helmet";
import Notes from "@shared/notes";
import StarKidFill from "@assets/images/icons/kidStarFill.svg";
import InfoIcon from "@assets/images/InfoIcon.svg";
import Button from "@components/base/button";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { profileTypeEndPoint } from "./profile-enum";
import { isContactScanDataHandler } from "@redux/ProfileContacts/profileContactsSlice";
import * as Sentry from "@sentry/browser";
import AddCompaniesToWorkspaceModal from "@routes/workspace/components/AddCompaniesToWorkspaceModal";

const companyProfileAPIEndPoints = {
  saveFavouriteCompanies: getApiUrl("addFavouriteCompany"),
  saveSearch: getApiUrl("saveSearch"),
  getCompanySlug: getApiUrl("companyProfiles/getSlug"),
};

const ProfileHeader = ({ loading = false, profileDetails, copyText = [], copyTextPill = [], showProfilePill = false, showFavourites = false, profileType, profileId, isSalesForce, isStarterPlan, isProfileViewExhaust }) => {
  const [showFavModal, setShowFavModal] = useState(false);
  const [prospectData, setProspectData] = useState({});
  const [showEmailAlert, setShowEmailAlert] = useState(false);
  const [showAddWorkspaceModal, setShowAddWorkspaceModal] = useState(false);
  const [showPopOver, setShowPopOver] = useState(false);
  const [isEmailAlert, setEmailAlert] = useState(false);
  const { search: searchUrlParams } = useLocation();
  const dispatch = useDispatch();
  const { countDetails, isParentSubs, companyProfileType } = useSelector((state) => state[profileType === "ports" ? "portProfile" : profileType === "logistics" ? "logisticsProfile" : "companyProfile"]);
  const [isFavourite, setIsFavourite] = useState(false);
  const isMerged = new URLSearchParams(searchUrlParams).get("isMerged") === "true" ? true : false;
  const { supplierCaching, buyerCaching, companyCategory } = useSelector((state) => state["companyProfile"]);
  const urlParams = new URLSearchParams(searchUrlParams);
  const DATASOURCE = urlParams.get("country");
  const profileLocked = urlParams.get("profileLocked");
  const tradeDirection = urlParams.get("tab") ? (urlParams.get("tab") === "E" ? "EXPORT" : "IMPORT") : "";

  useEffect(() => {
    if (profileDetails?.is_email_alert) {
      setEmailAlert(profileDetails.is_email_alert);
    }
    if (profileDetails?.is_favourite) {
      setIsFavourite(profileDetails.is_favourite);
    }
  }, [profileDetails, showFavModal]);

  useEffect(() => {
    if (profileId && !profileLocked && !isProfileViewExhaust) {
      fetchContactData();
    }
  }, [profileId]);

  const fetchContactData = async () => {
    try {
      const requestPayload = {
        company_id: profileId,
        data_availability: true,
      };
      const res = await axios.post(profileTypeEndPoint.getContactScaningData, requestPayload);
      const { data } = res.data;
      if (data === true) dispatch(isContactScanDataHandler(true));
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const addToProspect = () => {
    trademoTrackingEvents(trackingEventDictionary.companyProfilePageAddToFavouritesButton, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", ""));

    const requestObject = [
      {
        company_name: profileDetails?.companyName || profileDetails.name,
        company_id: profileDetails?.elastic_data_id,
        company_country: profileDetails?.country ?? "",
        trade_direction: "import",
        data_source: "multicountry",
      },
    ];
    setProspectData(requestObject);
    setShowFavModal(true);
  };
  const addToFavourite = () => {
    trademoTrackingEvents(trackingEventDictionary.companyProfileSetEmailAlertConfirm, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", ""));
    let requestObj = [
      {
        company_id: profileDetails?.elastic_data_id?.[0] ?? "",
        isAppendTags: true,
        is_merged: false,
        company_name: profileDetails?.companyName || profileDetails.name,
        trade_direction: "import",
        company_country: profileDetails?.country,
        data_source: "multicountry",
        company_type: "import",
        type: profileType,
      },
    ];

    const filteredApiUrl = companyProfileAPIEndPoints.saveFavouriteCompanies;
    axios
      .post(filteredApiUrl, requestObj)
      .then(() => {
        saveSearchHandler(requestObj);
      })
      .catch(() => {
        toast.error(ERROR_MSG);
      });
  };

  const saveSearchHandler = () => {
    const filteredApiUrl = companyProfileAPIEndPoints.saveSearch;
    let requestObject = {
      company_name: profileDetails?.companyName || profileDetails.name,
      company_id: profileDetails?.elastic_data_id?.[0] ?? "",
      company_country: profileDetails?.country,
      trade_direction: "import",
      data_source: "multicountry",
      is_email_alert: true,
      frequency: 30,
      source: "company",
      url: window.location.href,
      type: profileType,
    };
    axios
      .post(filteredApiUrl, requestObject)
      .then(() => {
        toast.success("Email alert for this company has been successfully created. You can also view and modify the alerts from your Favourite Companies list in the Dashboard.");
        setShowEmailAlert(false);
        setEmailAlert(true);
      })
      .catch(() => {
        toast.error("Email alert for this company could not be created.");
      });
  };

  const getSlugHandler = (index) => {
    const params = {
      companyId: countDetails.merged_company_ids[index],
    };
    axios.get(companyProfileAPIEndPoints.getCompanySlug, { params }).then((res) => {
      if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
        if (res?.data?.data?.companySlug) {
          let url = "";
          let country = "multicountry";
          url = getIntelUrl() + res.data.data.companySlug + "/" + res.data.data.aliasCompanyId + `?country=${country}&type=import&tab=` + companyProfileType;
          if (!!url && url !== "") {
            window.open(url, "_blank");
          } else {
            toast.error(ERROR_MSG);
          }
        } else {
          toast.error("No company profile found in our system !!!");
        }
      } else {
        toast.error("No company profile found in our system !!!");
      }
    });
  };

  return (
    <>
      {isStarterPlan && loading ? (
        <div className="tw-mt-1">
          <LoadingSkeleton lines={1} lineHeight="10px" width="10%" shape="rectangle" widthArr={["20%", "30%", "40%", "50%"]} />
        </div>
      ) : isStarterPlan ? (
        <div className="tw-pl-3">
          <p className="tw-text-sm text-left tw-pt-3 tw-px-0 tw-flex tw-items-center tw-gap-1">
            <span>
              <img src={InfoIcon} alt="..." className="img-fluid" width={24} height={24} />
            </span>
            Remaining Profile Views:{" "}
            <strong className=" tw-px-2 tw-py-0.5 tw-rounded-[30px] tw-border-none tw-bg-semantic-orange-200 tw-text-xs tw-font-medium tw-text-semantic-orange-600">
              <span>{profileDetails.profileViewsStarter && profileDetails.profileViewsStarter?.maxAllowed !== 0 && profileDetails.profileViewsStarter?.currCount <= profileDetails.profileViewsStarter?.maxAllowed ? <span>{profileDetails.profileViewsStarter?.maxAllowed - profileDetails.profileViewsStarter?.currCount}</span> : " 0"}</span> for the day
            </strong>
          </p>
        </div>
      ) : (
        <></>
      )}
      <div className={`${styles.profileHeaderContainer} ${profileType === "company" ? "tw-mx-3 tw-pl-3 tw-bg-gray-50 tw-pb-2.5 tw-border-x-[1px]" : ""}`}>
        {loading ? (
          <LoadingSkeleton lines={4} lineHeight="20px" width="50%" shape="rectangle" widthArr={["20%", "30%", "40%", "50%"]} />
        ) : (
          <>
            <div className={`${styles.headingContainer} `}>
              <Helmet>
                <title>{`${profileDetails?.name ?? ""} | ${BRAND.titleSuffix}`}</title>
                <meta name="robots" content="noindex" />
              </Helmet>
              <div className={`${styles.portHeading} ${profileType === "company" ? "tw-flex tw-flex-col tw-items-start tw-pt-4 tw-gap-3" : ""} ${isSalesForce || profileLocked ? "tw-py-2.5" : ""} `}>
                {profileDetails.name ? <div className={styles.portName}>{profileDetails.name}</div> : null}
                {isMerged ? (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowPopOver(!showPopOver);
                    }}
                    className="merged-company-tab">
                    <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1676900421/intel/icons/format_list_bulleted_gc5xwc.svg`} />
                    <span className="ml-1">View {countDetails && countDetails?.merged_company_ids ? countDetails?.merged_company_ids?.length : null} companies</span>
                    {showPopOver ? (
                      <div className="merge-company-popover">
                        {countDetails?.merged_company_names?.map((item, index) => {
                          return (
                            <div onClick={() => getSlugHandler(index)} className="d-flex justify-content-between mb-3 merge-company-popover-content">
                              <div className="merge-company-popover-content-name">
                                <span>
                                  {item ? item.slice(0, 30) : ""}
                                  {!!item && item.length > 30 ? "..." : ""}
                                </span>
                                <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1656316441/intel/dashboard%202.0/share-box-line_w6vjdh.svg`} className="pl-1"></img>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <></>
                    )}
                  </button>
                ) : (
                  ""
                )}
                {showProfilePill !== false ? (
                  <>
                    {profileDetails?.is_vocc && (
                      <span className={styles.profileName}>
                        <span className="mr-1">VOCC</span>
                      </span>
                    )}
                    {profileDetails?.is_nvocc && (
                      <span className={styles.profileName}>
                        <span className="mr-1">NVOCC</span>
                      </span>
                    )}

                    {profileDetails?.is_freight_forwarder && (
                      <span className={styles.profileName}>
                        <span className="mr-1">Freight Forwarder</span>
                      </span>
                    )}
                  </>
                ) : null}
                {profileType !== type.ports && (
                  <div>
                    <span className={styles.portAddress}>{profileDetails.address}</span>
                    <ReactCountryFlag className="trademo-search-flag data-source-country-flag mr-2 " countryCode={profileDetails.countryCode} svg />
                  </div>
                )}
              </div>
              <div className={styles.parentSubsContainer}>
                {countDetails?.is_parent_company || (buyerCaching?.profileDetails?.is_parent_company && companyCategory === "importers") || (supplierCaching?.profileDetails?.is_parent_company && companyCategory === "exporters") ? (
                  <div className="parent_subs_options py-2">
                    <div className="ml-2 h-100">
                      {profileType !== "company" && (
                        <div className="d-flex align-items-center" id="parent-switch">
                          <span className="mr-1 two_level_label">Include Subsidiaries Data</span>
                          <span className={isParentSubs ? "twolevel-checkbox" : "twolevel-checkbox-uncheck"}>
                            <Form.Check
                              type="switch"
                              id="custom-switch-5"
                              checked={isParentSubs}
                              onChange={(e) => {
                                dispatch(parentStatusHandler(e.target.checked));
                                dispatch(resetCachingHandler());
                              }}
                            />
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                {profileType === "company" && Array.isArray(copyText) && copyText.length > 0 ? (
                  <div className={"tw-flex tw-flex-wrap tw-gap-1 tw-pr-2 tw-justify-end"}>
                    {copyText.map(({ key, label, isCopy }, index) => {
                      const pillColors = ["#FFF9E6", "#E6F5E6", "#FFE6F0", "#E6F0FF"];
                      const backgroundColor = pillColors[index % pillColors.length];
                      return <ProfileHeaderPill profileType={profileType} key={key.toLowerCase()} label={key} value={label} backgroundColor={backgroundColor} isCopy={isCopy} handleCopy={handleCopy} />;
                    })}
                  </div>
                ) : null}
              </div>
              {profileType !== "company" && (
                <div>
                  {!isSalesForce && !profileLocked && (
                    <div className="d-flex">
                      {!isMerged && showFavourites && type.company === profileType ? (
                        isEmailAlert ? (
                          <div data-for="email-alert" data-tip="You've already set an alert for this company. To modify the alert, simply visit your Favourite Companies located in the Dashboard." className="d-flex align-items-center mx-3">
                            <img className="mr-1" src={`${CLOUDINARY_INTEL_URL}/icons/notifications_active_ofvtku.svg`} /> <span className="email-alert-allReadySet">Alert Set</span>
                            <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="bottom" id="email-alert" />
                          </div>
                        ) : (
                          <Button
                            id="email-alert"
                            className="mx-2"
                            variant={"primaryLightWithIcon"}
                            size={"large"}
                            onClick={() => {
                              trademoTrackingEvents(trackingEventDictionary.companyProfileSetEmailAlert, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", ""));
                              setShowEmailAlert(true);
                            }}>
                            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687514151/intel/icons/notifications_tjfihw.svg" alt="email_alert" className="img-fluid mr-1" /> Set Email Alert
                          </Button>
                        )
                      ) : (
                        <></>
                      )}
                      <Notes count={profileDetails.notes_count} id={profileDetails.favourite_id} profileDetails={profileDetails} profileType={profileType} type={"import"} tradeDirection={"import"} country={profileDetails?.country} dataSource={"multicountry"} comingFrom="company" setIsFavourite={setIsFavourite} />
                      {!isMerged && showFavourites ? (
                        <div>
                          <Button className="mx-2" variant={"primaryLightWithIcon"} size={"large"} onClick={() => addToProspect()}>
                            {isFavourite ? <img className="bookmarked_icon" src={StarKidFill} width={20} height={20} /> : <span className="material-symbols-outlined">kid_star</span>}
                            <span className="ml-1">{isFavourite ? "Bookmarked" : "Bookmark"}</span>
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              )}
              <div />
            </div>
            {profileDetails.address && profileType !== type.ports && profileType !== type.company ? (
              <div>
                <span className={styles.portAddress}>{profileDetails.address}</span>
                <ReactCountryFlag className="trademo-search-flag data-source-country-flag mr-2 " countryCode={profileDetails.countryCode} svg />
              </div>
            ) : null}
            {profileDetails.country && !profileDetails.address && !["ports", "company"].includes(profileType) ? (
              <div className="d-flex align-items-center">
                <span className={styles.portAddress}>
                  {profileDetails.state && profileDetails.state + ", "} {profileDetails.country}
                </span>
                <ReactCountryFlag className="trademo-search-flag data-source-country-flag mr-2 " countryCode={profileDetails.countryCode} svg />
              </div>
            ) : null}
            {profileType !== "company" && Array.isArray(copyText) && copyText.length > 0 ? (
              <div className={styles.profileHeaderTextItems}>
                {copyText.map(({ key, label, isWebsite, isCopy, tooltipLabel }, index) => (
                  <ProfileHeaderText key={key.toLowerCase()} label={key} value={label} isWebsite={isWebsite} isLast={index === copyText.length - 1} isCopy={isCopy} handleCopy={handleCopy} tooltipLabel={tooltipLabel} />
                ))}
              </div>
            ) : null}
            {profileType !== "company" && Array.isArray(copyTextPill) && copyTextPill.length > 0 ? (
              <div className={styles.profileHeaderTextItems}>
                {copyTextPill.map(({ key, label, backgroundColor, isCopy }, index) => (
                  <ProfileHeaderPill profileType={profileType} key={key.toLowerCase()} label={key} value={label} isLast={index === copyTextPill.length - 1} backgroundColor={backgroundColor} isCopy={isCopy} handleCopy={handleCopy} />
                ))}
              </div>
            ) : null}
          </>
        )}
        {showFavModal ? <AddFavModal id={profileDetails?.elastic_data_id?.[0]} profileType={profileType} show={showFavModal} handleClose={() => setShowFavModal(false)} prospectData={prospectData} type={tradeDirection} tradeDirection={tradeDirection} country={profileDetails?.country} dataSource={DATASOURCE} setIsFavourite={setIsFavourite} /> : <></>}
        {showEmailAlert ? (
          <CompanyProfileEmailAlertModal
            show={showEmailAlert}
            handleClose={() => {
              setShowEmailAlert(false);
            }}
            addToFavourite={() => addToFavourite()}
            company_name={profileDetails?.name}
          />
        ) : (
          <></>
        )}
        {showAddWorkspaceModal ? (
          <AddCompaniesToWorkspaceModal
            show={showAddWorkspaceModal}
            onHide={() => setShowAddWorkspaceModal(false)}
            companies={[
              {
                key: profileDetails?.companyName || profileDetails?.name,
                hashed_id: profileDetails?.elastic_data_id?.[0],
                company_country: profileDetails?.country,
                address: profileDetails?.address,
              },
            ]}
            selectProspectType
            // Only offer the side(s) the company actually trades on; picking the other one returns no shipment data.
            availableProspectTypes={[profileDetails?.isBuyer && "buyer", profileDetails?.isSupplier && "supplier"].filter(Boolean)}
            onSuccess={() => setShowAddWorkspaceModal(false)}
            source="company_profile"
          />
        ) : (
          <></>
        )}
      </div>
      {profileType === "company" && !countDetails.loading && (
        <div className="tw-flex tw-items-center tw-py-5 tw-gap-3 tw-pl-3 tw-relative">
          <div className="tw-absolute tw-border tw-border-t-0 tw-rounded-b-lg tw-mx-3 tw-inset-x-0 tw-top-0 tw-h-1/2 tw-bg-gray-50 tw-pointer-events-none -tw-z-10"></div>
          <div className="tw-flex tw-gap-2 tw-pl-3">
            {(countDetails?.is_parent_company || (buyerCaching?.profileDetails?.is_parent_company && companyCategory === "importers") || (supplierCaching?.profileDetails?.is_parent_company && companyCategory === "exporters")) && (
              <div className="d-flex align-items-center tw-py-2 tw-px-3 tw-border tw-border-gray-200 tw-rounded-[20px] tw-shadow-autoSuggestPill tw-bg-white" id="parent-switch">
                <span className="mr-1 two_level_label">Include Subsidiaries Data</span>
                <span className={isParentSubs ? "twolevel-checkbox" : "twolevel-checkbox-uncheck"}>
                  <Form.Check
                    type="switch"
                    id="custom-switch-5"
                    checked={isParentSubs}
                    onChange={(e) => {
                      dispatch(parentStatusHandler(e.target.checked));
                      dispatch(resetCachingHandler());
                    }}
                  />
                </span>
              </div>
            )}
            {!isSalesForce && !profileLocked && (
              <div className="d-flex tw-gap-3">
                {!isMerged && showFavourites && type.company === profileType ? (
                  <>
                    {isEmailAlert ? (
                      <div data-for="email-alert" data-tip="You've already set an alert for this company. To modify the alert, simply visit your Favourite Companies located in the Dashboard." className="tw-w-10 tw-h-10 tw-border tw-rounded-lg tw-bg-white tw-shadow-autoSuggestPill tw-border-gray-200 tw-flex tw-items-center tw-justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5a1ce2">
                          <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Zm-40-280h80v-80h80v-80h-80v-80h-80v80h-80v80h80v80Z" />
                        </svg>
                      </div>
                    ) : (
                      <button
                        data-for="email-alert"
                        data-tip="Set Email Alert"
                        id="email-alert"
                        className="tw-w-10 tw-h-10 tw-border tw-rounded-lg tw-bg-white tw-shadow-autoSuggestPill tw-border-gray-200"
                        onClick={() => {
                          trademoTrackingEvents(trackingEventDictionary.companyProfileSetEmailAlert, generateTrackingObject("intel", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", ""));
                          setShowEmailAlert(true);
                        }}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#101828">
                          <path d="M440-360h80v-80h80v-80h-80v-80h-80v80h-80v80h80v80ZM160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z" />
                        </svg>
                      </button>
                    )}
                    <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="right" effect="solid" id="email-alert" />
                  </>
                ) : (
                  <></>
                )}
                <Notes showText={false} count={profileDetails.notes_count} id={profileDetails.favourite_id} profileDetails={profileDetails} profileType={profileType} type={"import"} tradeDirection={"import"} country={profileDetails?.country} dataSource={"multicountry"} comingFrom="company" setIsFavourite={setIsFavourite} />
                {!isMerged && showFavourites ? (
                  <div data-for="bookmark-company" data-tip="Bookmark">
                    <button className="tw-w-10 tw-h-10 tw-border tw-rounded-lg tw-bg-white tw-shadow-autoSuggestPill tw-border-gray-200" onClick={() => addToProspect()}>
                      {isFavourite ? (
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5a1ce2">
                          <path d="m233-120 65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#101828">
                          <path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z" />
                        </svg>
                      )}
                    </button>
                    <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="right" effect="solid" id="bookmark-company" />
                  </div>
                ) : null}
                {!isMerged && showFavourites ? (
                  <div data-for="add-to-workspace-company" data-tip="Add to Workspace">
                    <button className="tw-w-10 tw-h-10 tw-border tw-rounded-lg tw-bg-white tw-shadow-autoSuggestPill tw-border-gray-200" onClick={() => setShowAddWorkspaceModal(true)}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#101828">
                        <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640H447l-80-80H160v480l96-320h684L837-217q-8 26-29.5 41.5T760-160H160Zm84-80h516l72-240H316l-72 240Zm0 0 72-240-72 240Zm-84-400v-80 80Z" />
                      </svg>
                    </button>
                    <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="right" effect="solid" id="add-to-workspace-company" />
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileHeader;
